// extracted by mini-css-extract-plugin
export var aircallIframe = "_cl-3";
export var fabContainer = "_cl-5";
export var fabRinging = "_cl-6";
export var loadingOverlay = "_cl-4";
export var pulse = "_cl-7";
export var widgetContent = "_cl-2";
export var widgetPanel = "_cl-0";
export var widgetPanelExpanded = "_cl-1";